import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RatesState {
  rates: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: RatesState = {
  rates: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'rates',
  initialState,
  reducers: {
    fetchRateStart(state) {
      state.loading = true;
      state.error = null;
    },
    setRateData(state, action: PayloadAction<any>) {
      state.rates = action.payload;
      state.loading = false;
    },
    fetchRateError(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCurrencyState: () => initialState,
  },
});

export const { fetchRateError, fetchRateStart, setRateData, resetCurrencyState } =
  authSlice.actions;

export default authSlice.reducer;
